import { Grid } from '../joy/Grid';
import { Card } from '../joy/Card';
import React from 'react';
import { BaseItem, ItemListProps } from './types';
import { useDnd } from './useDnd';

interface DraggableCardProps<T extends BaseItem> {
  item: T;
  children: React.ReactNode;
  onDrop?: ItemListProps<T>['onDrop'];
  onItemClick?: ItemListProps<T>['onItemClick'];
}

export const DraggableCard = <T extends BaseItem>({ item, onItemClick, onDrop, children }: DraggableCardProps<T>) => {
  const { isDragging, aboutToBeDropped, canBeDropped, ref } = useDnd(item, onDrop);

  return (
    <Grid
      component="div"
      xs={12}
      sm={6}
      md={4}
      lg={3}
      key={item.id}
      // @ts-expect-error all
      ref={ref}
      sx={{
        opacity: isDragging ? 0.4 : 1,
        backgroundColor: aboutToBeDropped ? 'success.500' : canBeDropped ? 'success.200' : undefined,
      }}
    >
      <Card
        variant="outlined"
        sx={{
          cursor: 'pointer',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: 2,
          },
        }}
        onClick={() => onItemClick?.(item)}
      >
        {children}
      </Card>
    </Grid>
  );
};
